// extracted by mini-css-extract-plugin
export default {"menu-item":"Help_menu-item__R13Mn"};